import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { EnergyLabelContextProvider } from "@/components/Product/energyLabel/context/energyLabel.context";
import { AemEnergyLabelRenditions } from "@/components/Product/energyLabel/utils";

type Props = {
    energyLabel:
        | {
              eprelId: string | null;
              label: AemEnergyLabelRenditions | null;
              labelNested: string | null;
              altText: string;
          }
        | undefined;
    className?: string;
    children: ReactNode;
};

export const Base = ({ energyLabel, className, children }: Props) => {
    if (!energyLabel) return null;

    return (
        <div className={cn(className)}>
            <EnergyLabelContextProvider
                eprelId={energyLabel.eprelId}
                label={energyLabel.label}
                labelNested={energyLabel.labelNested}
                altText={energyLabel.altText}
            >
                {children}
            </EnergyLabelContextProvider>
        </div>
    );
};
